module.exports = __webpack_public_path__ + "img/gov-up2.d36ff08b.svg";